'use client';

import { createContext } from 'react';

const CollectionsContext = createContext(undefined);

export default CollectionsContext;
